import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import _ from "vendor/lodash";
import Immutable from "community/immutable";
import "vendor/es6-promise";
import Module from "global/sparta-module-utility";
import spartaStyleUtility from "global/sparta-style-utility";
import Utility from "community/module-utils-utility";
import Ep from "modules/home-loans/services-home-loans-module/2.2.0/js/endpoints-services-home-loans-module";
import spartaTemplates from "modules/home-loans/services-home-loans-module/2.2.0/js/templates";
import "css!modules/home-loans/services-home-loans-module/2.2.0/css/services-home-loans-module.scss.css";
/**
 * @method hasRates
 *
 * @param payload - the response to a rates AJAX call
 * @returns true if any product provides a valid rate
 */
const hasRates = (payload) => {
  return payload.mortgageProducts && _.some(payload.mortgageProducts, (product) => product.rateDetails && product.rateDetails.rate);
};

export default {

  mortgageRates (calcInput) {

    // get mortgage rates endpoint url
    const url = spaParams.siteParams.endpoints.mortgage.url;

    let payloadTemp = JSON.parse($('#ratePayloads').text());
    payloadTemp = payloadTemp[spaParams.pageParams.payload];

    let payload = payloadTemp.payloads;
    let debugData = payloadTemp.debugData || {};

    //if calcInput then replace spa params
    if (calcInput) {
      payload.mortgage.rateInputs.postalCode = calcInput.rateInputs.postalCode;
      payload.mortgage.rateInputs.purchasePrice = calcInput.rateInputs.purchasePrice;
      payload.mortgage.rateInputs.amountBorrowed = calcInput.rateInputs.amountBorrowed;
      payload.mortgage.rateInputs.downPayment = calcInput.rateInputs.downPayment;
    }

    payload = payload.mortgage;


    // Let's create the promise for mortgage rates request
    const mortgageRatesRequest = Ep.rates(url, payload, debugData);

    return mortgageRatesRequest

      .then(payload => {

        if (hasRates(payload)) {
          const rateInputs = payload.rateInputs;
          const rates = Object.assign({}, payload, {
            rateInputs: Object.assign({}, rateInputs, {
              downpaymentPercentage: 100.00 - rateInputs.loantoValueRatio
            }),
            mortgageProducts: payload.mortgageProducts.map(product => {
              const rateDetails = product.rateDetails;
              const pmi = rateDetails && rateDetails.mortgageInsuranceAmount;
              if (pmi) {
                const armAssumptions = rateDetails.armAssumptions;
                if (armAssumptions) {
                  const paymentTypes = [
                    'armInitialPaymentAmount',
                    'armFullyIndexedRatePaymentAmount',
                    'armSubsequentPaymentAdjustAmount_1',
                    'armSubsequentPaymentAdjustAmount_2',
                    'armSubsequentPaymentAdjustAmount_3',
                    'armMaximumInitialRatePayment',
                    'armMaximumSubsequentResetPayment',
                    'armMaximumLifetimePayment'
                  ];
                  paymentTypes.forEach(type => {
                    const paymentAmount = armAssumptions && armAssumptions[type];
                    if (paymentAmount) {
                      armAssumptions[type] += pmi;
                    }
                  });
                }
                if (rateDetails.monthlyPayment) {
                  rateDetails.monthlyPayment += pmi;
                }
              }
              return product;
            })
          });
          return Promise.resolve(rates);
        } else {
          return Promise.reject({
            error: 'no rates were returned',
            rateInputs: payload.rateInputs
          });
        }

      })

      .catch(error => {

        return Promise.reject({
          ...error,
          rateInputs: payload.rateInputs
        });

      });

  },

  refinanceRates (calcInput) {

    // get refinance rates endpoint url
    const url = spaParams.siteParams.endpoints.refinance.url;

    let payloadTemp = JSON.parse($('#ratePayloads').text());
    payloadTemp = payloadTemp[spaParams.pageParams.payload];

    let payload = payloadTemp.payloads;
    let debugData = payloadTemp.debugData || {};

    //if valid zip
    // if (zipInput) {
    //   if (/\d{5}/.test(zipInput.postalCode)) {
    //     payload.refinance.rateInputs.postalCode = zipInput.postalCode;
    //   }
    // }

    //if calcInput then replace spa params
    if (calcInput) {
      payload.refinance.rateInputs.postalCode = calcInput.rateInputs.postalCode;
      payload.refinance.rateInputs.purchasePrice = calcInput.rateInputs.purchasePrice;
      payload.refinance.rateInputs.amountBorrowed = calcInput.rateInputs.amountBorrowed;
      payload.refinance.rateInputs.downPayment = calcInput.rateInputs.downPayment;
    }


    payload = payload.refinance;

    // Let's create the promise for refinance rates request
    const refinanceRatesRequest = Ep.rates(url, payload, debugData);

    return refinanceRatesRequest

      .then(payload => {

        if (hasRates(payload)) {
          const rates = payload;
          return Promise.resolve(rates);
        } else {
          return Promise.reject({
            error: 'no rates were returned',
            rateInputs: payload.rateInputs
          });
        }

      })

      .catch(error => {

        return Promise.reject({
          ...error,
          rateInputs: payload.rateInputs
        });

      });


  },

  homeEquityRates () {

    // collect page params for home equity
    const $ratePayloads = $('#ratePayloads');
    const payloads = JSON.parse($ratePayloads.text());

    const inputs = payloads.homeEquityOverview;
    inputs.state = this.Store.getUserSelectedState();
    if (!inputs.state) {
      inputs.state = spaParams.pageParams.defaultState;
      this.Store.addData('state', inputs.state || '');
    }

    // create homeEquity rates request
    const homeEquityRatesRequest = Ep.rates(spaParams.siteParams.endpoints.homeEquity.url, inputs);

    // run homeEquity rates request
    return homeEquityRatesRequest
      .then(payload => {
        this.Store.addData('home_equity_rates', payload);
        return Promise.resolve(payload);
      })
      .catch(error => {
        return Promise.reject({
          ...error,
          rateInputs: payload.rateInputs
        });
      });
  },

  assumptionsRates () {

    const params = Utility.getQueryParamValues(window.location.href);
    const loanType = (params && params.loanType) || spaParams.pageParams.loanType;

    const rates = this.Store.getData(`${loanType}AssumptionsRates`);
    if (rates) {
      return Promise.resolve(rates);
    }

    // collect page params for home equity
    const $ratePayloads = $('#ratePayloads');
    const payloads = JSON.parse($ratePayloads.text());

    const defaultInputs = payloads.assumptions.payloads[loanType];
    const rateInputs = defaultInputs.rateInputs;
    let inputs;
    if (loanType === 'homeEquity') {
      const state = params && params.state;
      inputs = Object.assign({}, defaultInputs, {
        state
      });
    } else {
      const postalCode = params && params.zipcode || rateInputs.postalCode;
      const purchasePrice = new Number(params && params.purchasePrice || rateInputs.purchasePrice);
      const downPayment = new Number(params && params.downPayment || rateInputs.downPayment);
      const downpaymentPercentage = rateInputs.downpaymentPercentage || (downPayment / purchasePrice) * 100.;
      const amountBorrowed = purchasePrice - downPayment;
      const overrides = Object.assign({}, defaultInputs.rateInputs, {
        postalCode,
        purchasePrice,
        downPayment,
        downpaymentPercentage,
        amountBorrowed
      });
      inputs = Object.assign({}, defaultInputs, {
        rateInputs: overrides
      });
    }

    const url = spaParams.siteParams.endpoints[loanType].url;

    // create rates request
    const debugData = payloads.assumptions.debugData[loanType];
    const ratesRequest = Ep.rates(url, inputs, debugData);

    // run rates request
    return ratesRequest
      .then(response => {
        if (/^(mortgage|refinance)$/.test(loanType)) {
          const rateInputs = response.rateInputs;
          const rates = Object.assign({}, response, {
            rateInputs: Object.assign({}, rateInputs, {
              downpaymentPercentage: 100.00 - rateInputs.loantoValueRatio
            }),
            mortgageProducts: _.fromPairs(response.mortgageProducts.map((product) => {
              const key = product.productCode;
            //   const rateDetails = product.rateDetails;
            //   const pmi = rateDetails && rateDetails.mortgageInsuranceAmount;
            //   if (pmi) {
            //     const armAssumptions = rateDetails.armAssumptions;
            //     if (armAssumptions) {
            //       const paymentTypes = [
            //         'armInitialPaymentAmount',
            //         'armFullyIndexedRatePaymentAmount',
            //         'armSubsequentPaymentAdjustAmount_1',
            //         'armSubsequentPaymentAdjustAmount_2',
            //         'armSubsequentPaymentAdjustAmount_3',
            //         'armMaximumInitialRatePayment',
            //         'armMaximumSubsequentResetPayment',
            //         'armMaximumLifetimePayment'
            //       ];
            //       paymentTypes.forEach(type => {
            //         const paymentAmount = armAssumptions && armAssumptions[type];
            //         if (paymentAmount) {
            //           armAssumptions[type] += pmi;
            //         }
            //       });
            //     }
            //     if (rateDetails.monthlyPayment) {
            //       rateDetails.monthlyPayment += pmi;
            //     }
            //   }
              return [key, product];
            }))
          });
          this.Store.addData(`${loanType}AssumptionsRates`, rates);
          return Promise.resolve(rates);
        } else {
          return Promise.resolve(response);
        }
      })
      .catch(error => {
        return Promise.reject(error);
      });
  },

  closingCostCalculatorRates (calcInput){
    // get mortgage rates endpoint url
    const url = spaParams.siteParams.endpoints.closingCosts.url;

    let payloadTemp = JSON.parse($('#ratePayloads').text());
    payloadTemp = payloadTemp[spaParams.pageParams.payload];

    let payload = payloadTemp.payloads;
    //just take the first element from the debug array since we really just want some fake dollar amounts
    let debugData = payloadTemp.debugData || {};
    if (debugData.mortgageProducts) {
      debugData.mortgageProducts.splice(1, debugData.mortgageProducts.length - 1);
    }


    //if calcInput then replace spa params
    if (calcInput) {
      payload.mortgage.rateInputs.postalCode = calcInput.rateInputs.postalCode;
      payload.mortgage.rateInputs.purchasePrice = calcInput.rateInputs.purchasePrice;
      payload.mortgage.rateInputs.amountBorrowed = calcInput.rateInputs.amountBorrowed;
      payload.mortgage.rateInputs.downPayment = calcInput.rateInputs.downPayment;
      payload.mortgage.rateInputs.downpaymentPercentage = calcInput.rateInputs.downpaymentPercentage;

      //based on product we need delete other elements
      var productWeNeed = $.grep(payload.mortgage.mortgageProducts, function (v) {
        return v.productName == calcInput.rateInputs.mappingProduct;
      });
    }

    payload = payload.mortgage;

    //construct fresh object so we don't update mortgage products reference and reduce it to a 1 element array
    let payloadFinal = {"rateInputs": payload["rateInputs"], "mortgageProducts": productWeNeed};


    // Let's create the promise for mortgage rates request
    const mortgageRatesRequest = Ep.rates(url, payloadFinal, debugData);

    return mortgageRatesRequest

      .then(payload => {

        if (hasRates(payload)) {
          return Promise.resolve(payload);
        } else {
          return Promise.reject({error: 'no rates were returned'});
        }

      })

      .catch(error => {

        return Promise.reject(error);

      });


  },

  /**
   * @method mortgageCalculatorRates
   * @param {Object} calcInput
   */
  mortgageCalculatorRates (calcInput){
    // get mortgage rates endpoint url
    const url = spaParams.siteParams.endpoints.mortgage.url;

    let payloadTemp = JSON.parse($('#ratePayloads').text());
    payloadTemp = payloadTemp[spaParams.pageParams.payload];

    let payload = payloadTemp.payloads;
    //just take the first element from the debug array since we really just want some fake dollar amounts
    let debugData = payloadTemp.debugData || {};
    if (debugData.mortgageProducts) {
      debugData.mortgageProducts.splice(1, debugData.mortgageProducts.length - 1);
    }


    //if calcInput then replace spa params
    if (calcInput) {
      payload.mortgage.rateInputs.postalCode = calcInput.rateInputs.postalCode;
      payload.mortgage.rateInputs.purchasePrice = calcInput.rateInputs.purchasePrice;
      payload.mortgage.rateInputs.amountBorrowed = calcInput.rateInputs.amountBorrowed;
      payload.mortgage.rateInputs.downPayment = calcInput.rateInputs.downPayment;
      payload.mortgage.rateInputs.downpaymentPercentage = calcInput.rateInputs.downpaymentPercentage;

      //based on product we need delete other elements
      var productWeNeed = $.grep(payload.mortgage.mortgageProducts, function (v) {
        return v.productCode == calcInput.rateInputs.mappingProduct;
      });
    }

    payload = payload.mortgage;

    //construct fresh object so we don't update mortgage products reference and reduce it to a 1 element array
    let payloadFinal = {"rateInputs": payload["rateInputs"], "mortgageProducts": productWeNeed};


    // Let's create the promise for mortgage rates request
    const mortgageRatesRequest = Ep.rates(url, payloadFinal, debugData);

    return mortgageRatesRequest

      .then(payload => {

        if (hasRates(payload)) {
          return Promise.resolve(payload);
        } else {
          return Promise.reject({error: 'no rates were returned'});
        }

      })

      .catch(error => {

        return Promise.reject(error);

      });


  },

  /**
   * @method refinanceCalculatorRates
   * @param {Object} calcInput
   */
  refinanceCalculatorRates (calcInput){
    // get mortgage rates endpoint url
    const url = spaParams.siteParams.endpoints.refinance.url;

    let payloadTemp = JSON.parse($('#ratePayloads').text());
    payloadTemp = payloadTemp[spaParams.pageParams.payload];

    let payload = payloadTemp.payloads;
    //just take the first element from the debug array since we really just want some fake dollar amounts
    let debugData = payloadTemp.debugData || {};
    if (debugData.mortgageProducts) {
      debugData.mortgageProducts.splice(1, debugData.mortgageProducts.length - 1);
    }


    //if calcInput then replace spa params
    if (calcInput) {
      payload.refinance.rateInputs.postalCode = calcInput.rateInputs.postalCode;
      payload.refinance.rateInputs.purchasePrice = calcInput.rateInputs.purchasePrice;
      payload.refinance.rateInputs.amountBorrowed = calcInput.rateInputs.amountBorrowed;
      payload.refinance.rateInputs.downPayment = calcInput.rateInputs.downPayment;
      payload.refinance.rateInputs.downpaymentPercentage = calcInput.rateInputs.downpaymentPercentage;

      //based on product we need delete other elements
      var productWeNeed = $.grep(payload.refinance.mortgageProducts, function (v) {
        return v.productCode == calcInput.rateInputs.mappingProduct;
      });
    }

    payload = payload.refinance;

    //construct fresh object so we don't update mortgage products reference and reduce it to a 1 element array
    let payloadFinal = {"rateInputs": payload["rateInputs"], "mortgageProducts": productWeNeed};

    const refinanceRatesRequest = Ep.rates(url, payloadFinal, debugData);

    return refinanceRatesRequest

      .then(payload => {

        if (hasRates(payload)) {
          return Promise.resolve(payload);
        } else {
          return Promise.reject({error: 'no rates were returned'});
        }

      })

      .catch(error => {

        return Promise.reject(error);

      });
  },

  /**
   * @method leadsCall
   * @param {Object} payload
   */
  leadsCall (payload) {

    const inputs = {};

    // format email, zip, phone
    inputs.custEmail = payload.emailAddress.trim();
    inputs.mailZipcode = payload.zipCode.slice(0, 5);
    inputs.phoneDay = payload.phoneNumber.replace(/[^\d]/g, '').slice(0, 10);

    // names
    inputs.custFirstName = payload.firstName;
    inputs.custLastName = payload.lastName;

    // format mortgage loan purpose & sub campaign code
    inputs.mtgLoanPurpose = payload.mtgLoanPurpose || spaParams.pageParams.purpose;
    inputs.subCampaignCode = payload.subCampaignCode || spaParams.pageParams.subCampCode;

    // make leads call
    return Ep.leadsCall(spaParams.siteParams.endpoints.leadsCall.url, inputs)

    // on leads call success
      .then((payload) => {
        return Promise.resolve(payload);
      })

      // on leads call failure
      .catch((error) => {
        return Promise.reject(error);
      });

  },


  /**
   * @method leadPhoneNumber
   */
  leadPhoneNumber () {

    // params
    const params = Utility.getQueryParamValues(window.location.href);

    // get persisted campaign code
    const persistedSubCampCode = this.Store.getPersisted('subCampCode');
    let subCampCode = persistedSubCampCode && persistedSubCampCode.code;

    const keys = Object.keys(params || {});

    // if param exist
    let key = keys.find(key => /subcampcode/i.test(key) ? key : false);
    if (key) {
      subCampCode = params[key];
    }

    key = keys.find(key => /scscampcode/i.test(key) ? key : false);
    const scsCampCode = key && params[key];

    // sub campaign code
    if (!subCampCode) {
      subCampCode = spaParams.pageParams.subCampCode;
    }

    key = keys.find(key => /loanpurpose/i.test(key) ? key : false);
    const loanPurpose = (key && params[key]) || spaParams.pageParams.purpose;

    // there was some discussion of affiliate code coming from a cookie rather than a query param
    key = Object.keys(params || {}).find(key => /affiliatecode/i.test(key) ? key : false);
    let affiliateCode = key && params[key];
    if (!affiliateCode) {
      // try to read the affiliate code from a cookie
      const matches = document.cookie.match(/boa_hlts_mlo=([^;]+);/);
      if (matches && matches.length > 1) {
        affiliateCode = matches[1];
      }
    }
    if (affiliateCode) {
      return Ep.getAffiliateInfo(
        spaParams.siteParams.endpoints.getAffiliateInfo.url,
        affiliateCode,
        spaParams.siteParams.endpoints.getAffiliateInfo.debugData
      ).then(response => {
        const phone = response.phoneNumber;
        const matches = phone && phone.match(/(\d{3})(\d{3})(\d{4})/);
        if (matches.length > 3) {
          const digitGroups = matches.slice(1, 4);
          const phoneNumber = digitGroups.join('-');
          this.Store.addData('phoneNumber', {phoneNumber});
          this.Store.persist('subCampCode', {code: response.subCampCode});
          const {debugging, firstName: fName, lastName: lName} = response;
          const Source = 'MLOWebsite';
          const Subsource = 'Prequal';
          const originationCode = '18098';
          return Promise.resolve({
            debugging,
            scsCampCode,
            subCampCode,
            phoneNumber,
            affiliateCode,
            fName,
            lName,
            loanPurpose,
            Source,
            Subsource,
            originationCode,
            raw: response
          });
        } else {
          return Promise.reject({error: 'no valid phone number provided'});
        }
      }).catch(error => Promise.reject({error}));
    } else {
      const debugData = spaParams.siteParams.endpoints.leadsPhoneNumber.debugData;
      // lets make phone number call
      return Ep.leadsPhoneNumberEndpoint(spaParams.siteParams.endpoints.leadsPhoneNumber.url, subCampCode, scsCampCode, debugData)
        .then(payload => {

          // add to store
          this.Store.addData(`phoneNumber`, payload);

          // persist data
          this.Store.persist('subCampCode', {code: subCampCode});

          // return promise
          return Promise.resolve({scsCampCode, subCampCode, ...payload});

        })
        .catch(error => {

          // return promise
          return Promise.reject({error, scsCampCode, subCampCode});

        });

    }

  }

}
